import { cn } from '../../../lib/styles';
import { Icon } from '../icon/icon.spark';
import { Tooltip } from '../tooltip/tooltip.spark';
import type { HeadingColour, HeadingProps, HeadingStyle, HeadingWeight } from './types';

const HEADING_MAP: Record<HeadingStyle, string> = {
  xl: 'text-2xl gap-3',
  lg: 'text-xl gap-2',
  md: 'text-base gap-1.5',
  sm: 'text-sm gap-1',
} as const;

const COLOUR_MAP: Record<HeadingColour, string> = {
  black: 'text-spark-text-primary',
  white: 'text-spark-text-inverse',
} as const;

const WEIGHT_MAP: Record<HeadingWeight, string> = {
  normal: 'font-normal',
  semibold: 'font-semibold',
} as const;

export function Heading({
  style = 'lg',
  colour = 'black',
  weight = 'semibold',
  ...props
}: HeadingProps) {
  return (
    <props.level
      className={cn(
        'flex items-center',
        WEIGHT_MAP[weight],
        HEADING_MAP[style],
        COLOUR_MAP[colour],
      )}
    >
      {props.icon && <Icon name={props.icon} size={props.iconSize ?? style} />}
      {props.children && <span>{props.children}</span>}
      {props.tooltip && (
        <Tooltip content={props.tooltip}>
          <Icon name="infoCircle" size={style} />
        </Tooltip>
      )}
    </props.level>
  );
}
